import { Button, IconArrowLeft, spacing, SpaceBetween, styled } from '@lessonup/ui-components';
import React from 'react';
import { useEditorTranslation } from '../../../hooks/useEditorTranslation';

interface ThemeDetailHeaderProps {
  themeName: string;
  onBack: () => void;
}

export const ThemeDetailHeader: React.FC<ThemeDetailHeaderProps> = ({ themeName, onBack }) => {
  const { t } = useEditorTranslation();

  return (
    <StyledHeader>
      <SpaceBetween direction="x" spacing={spacing.size8} alignItems="center">
        <Button
          buttonType="neutral"
          showStroke={false}
          iconStart={<IconArrowLeft />}
          onClick={onBack}
          resizing="hug"
          aria-label={t('editor.themeModal.detail.backButton')}
        />
        <StyledThemeName>{themeName}</StyledThemeName>
      </SpaceBetween>
    </StyledHeader>
  );
};

const StyledHeader = styled.div`
  padding: ${spacing.size12} ${spacing.size12} ${spacing.size8};
`;

const StyledThemeName = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin: 0;
`;
